import { render } from "./SOSAlertMaster.vue?vue&type=template&id=4d722968&scoped=true"
import script from "./SOSAlertMaster.vue?vue&type=script&lang=js"
export * from "./SOSAlertMaster.vue?vue&type=script&lang=js"

import "./SOSAlertMaster.vue?vue&type=style&index=0&id=4d722968&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d722968"]])

export default __exports__